(function () {
    angular.module('PWAPoCApp').constant('appVersion', '23.03.14');
})();
